import 'css-chunksrc/client/pages/projectPage/synthesisPage/monitoring/tasksProgression/styles.scss';export default {
  "tasksProgression": "_tasksProgression_1pgm1_1",
  "title": "_title_1pgm1_5",
  "percentage": "_percentage_1pgm1_22",
  "hours": "_hours_1pgm1_27",
  "bar": "_bar_1pgm1_32"
};